<button [ngClass]="valueClass ? valueClass : ''" class="btn" (click)="buttonClick($event)">
  {{ value | translate }}
</button>
